// 营销中心(促销中心)
import qs from 'qs';
// import R3 from '@syman/burgeon-r3';
window.$network = R3.network;

export default {
  /**
   * 营销列表页面
   */
  // 查询列表
  selectPmList: params => $network.post('/api/cs/onlinepm/v1/selectPmList', params),
  // 查看日志
  cpromLogQuery: params => $network.post('/api/cs/onlinepm/v1/cpromLogQuery', params),
  // 获取button数组
  // 发布
  updatePmStatus: params => $network.post('/api/cs/onlinepm/v1/updatePmStatus', params),
  // 删除
  deletePm: params => $network.post('/api/cs/onlinepm/v1/deletePm', params),
  // 设置分组
  selectPmGroup: params => $network.post('/api/cs/onlinepm/v1/selectPmGroup', params),
  // 确定设置分组
  updatePmGroup: params => $network.post('/api/cs/onlinepm/v1/updatePmGroup', params),
  // 请求时间
  getweekdate: params => $network.post('/api/cs/onlinepm/getweekdate', params),
  // 查询当前行的信息
  selectPm: params => $network.post('/api/cs/onlinepm/v1/selectPm', params),
  cpromtypelistquery: params => $network.post('/p/cs/cpromtypelistquery', params),
  cpromactiquerylist: params => $network.post('/p/cs/cpromactiquerylist', params),
  cpromactiquery: params => $network.post('/p/cs/cpromactiquery', params),
  /**
   * 促销编辑页面
   */
  // 保存
  savePm: params => $network.post('/api/cs/onlinepm/v1/savePm', params),
  /**
   * 批量新增 获取sku编码
   */
  selectProInfoLike: params => $network.post('/api/cs/onlinepm/v1/selectProInfoLike', params),
  selectSendOrderProInfoLike: params => $network.post('/api/cs/onlinepm/v1/selectSendOrderProInfoLike', params),
  // 单品特价 - 更新/删除接口
  // modifyDetail: params => $network.post('/api/cs/onlinepm/v1/UpdateSpecialOfferByID', params),

  /**
   * 草稿保存
   */
  saveBatchPm: params => $network.post('/api/cs/onlinepm/v1/saveBatchPm', params),
  /**
   * 仿真试算
   */
  // 根据id获取表格其他数据
  selectProInfo: params => $network.post('/api/cs/onlinepm/v1/selectProInfo', params),
  // 仿真试算：
  testPm: params => $network.post('/api/cs/onlinepm/v1/testPm', params),
  // 导出
  cPromActiExport: params => $network.post('/api/cs/pm/v1/cPromActiExport', params),

  selectInit: params => $network.get(`/api/cs/onlinepm/v1/selectInit?${qs.stringify(params)}`,{ serviceId: "r3-pm" }),
  getPromField: (params) => $network.get("/api/cs/onlinepm/getPromField", params, { serviceId: "r3-pm" }),
  setMultiQuery: (params) => $network.get("/p/cs/setMultiQuery", params),

  // 促销-框架接口：
  screen: (params, serviceId = { serviceId: "r3-cp" }) => $network.post("/api/cs/md/screen", params, serviceId),
  screenresult: (params, serviceId = { serviceId: "r3-cp" }) => $network.post("/api/cs/md/screenresult", params, serviceId),
  screenresultcheck: (params, serviceId = { serviceId: "r3-cp" }) => $network.post("/api/cs/md/screenresultcheck", params, serviceId),
};
